<template>
    <ValidationObserver v-slot="{ handleSubmit }" ref="observer">
        <form class="text-black mt-4" @submit.prevent="handleSubmit(submit)">
            <p class="mb-4 text-xl font-semibold">Let's Connect</p>
            <div class="grid grid-cols-1 gap-4">
                <ValidationProvider
                    v-for="model in models"
                    :key="model.model"
                    tag="div"
                    :name="model.placeholder"
                    :rules="model.rules"
                    class="flex flex-col form-item"
                    v-slot="{ errors }"
                >
                    <label v-if="model.label" class="text-gray-600 block text-xs mb-0">{{ model.label }}</label>
                    <textarea
                        class="rounded form-item"
                        v-if="model.type == 'textarea'"
                        v-model="form_data[model.model]"
                        :id="model.model"
                        rows="6"
                        :placeholder="model.placeholder"
                    />
                    <input
                        class="rounded h-12"
                        :class="{ 'border-red-500': errors[0] }"
                        v-else
                        :type="model.type"
                        v-model="form_data[model.model]"
                        :placeholder="model.placeholder"
                    />
                    <span v-if="errors[0]" class="text-xs text-red-500 mt-1">{{ errors[0] }}</span>
                </ValidationProvider>
            </div>
            <vue-recaptcha
                :loadRecaptchaScript="true"
                ref="recaptcha"
                @verify="onCaptchaVerified"
                @expired="onCaptchaExpired"
                size="invisible"
                :sitekey="getKey"
            >
            </vue-recaptcha>
            <div v-if="success" class="border-brand border bg-brand bg-opacity-10 p-4 text-brand">
                <p class="font-semibold">Thank you for getting in touch! </p>
                <p class="text-sm">We appreciate you contacting First Down Funding. One of our colleagues will get back in touch with you soon!</p>
            </div>
            <button
                :disabled="loading"
                :class="loading && 'cursor-not-allowed opacity-50'"
                class="button--primary inline-flex items-center justify-center"
                type="submit"
            >
                <div v-if="loading" class="loader rounded-full border-2 border-t-2 border-gray-100 h-5 w-5 mr-2"></div>
                Submit
            </button>
        </form>
    </ValidationObserver>
</template>

<script>
const FORMSPARK_ACTION_URL = `https://submit-form.com/${process.env.MIX_RECAPTCHA_FORM}`;
import VueRecaptcha from 'vue-recaptcha';
import axios from 'axios';
import models from './form.data';
export default {
    components: { VueRecaptcha },
    data() {
        return {
            models,
            message: '',
            status: '',
            loading: false,
            success: false,
            form_data: {
                business_legal_name: '',
                first_name: '',
                email: '',
                cell_phone: '',
                contact_us_msg: ''
            }
        };
    },
    computed: {
        getKey() {
            return process.env.MIX_RECAPTCHA_SITE_KEY;
        }
    },
    methods: {
        onCaptchaVerified: function (recaptchaToken) {
            const self = this;
            self.status = 'submitting';
            self.loading = true;
            self.$refs.recaptcha.reset();
            axios
                .post(FORMSPARK_ACTION_URL, {
                    business_legal_name: self.form_data.business_legal_name,
                    first_name: self.form_data.first_name,
                    email: self.form_data.email,
                    cell_phone: self.form_data.cell_phone,
                    contact_us_msg: self.form_data.contact_us_msg,
                    'g-recaptcha-response': recaptchaToken
                })
                .then(() => {
                    self.success = true
                    window.location.href = `${window.location.hostname}/thank-you-page`
                })
                .catch(err => {
                    console.log(err);
                })
                .finally(() => {
                    self.status = '';
                    self.loading = false;
                    self.form_data = {
                        business_legal_name: '',
                        first_name: '',
                        email: '',
                        cell_phone: '',
                        contact_us_msg: ''
                    };
                    this.$refs.observer.reset();
                });
        },
        onCaptchaExpired: function () {
            this.$refs.recaptcha.reset();
        },
        submit() {
            this.$refs.recaptcha.execute();
        }
    }
};
</script>

<style lang="scss" scoped>
input {
    @apply mb-0 #{!important};
}
.form-item {
    margin-bottom: 0;
}
.loader {
    border-top-color: #ccc !important;
    animation: spinner 1.2s linear infinite;
}
@keyframes spinner {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>
